import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Button, IconButton } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import StopSharpIcon from "@mui/icons-material/StopSharp";

import "./style.scss"
import TaskTimer from "../../components/taskTimer";
import { clearTrackingState, setTrackingStartedAt, setTrackingState, setTrackingTimeLogged, } from "../../store/trackingSlice";
import moment from "moment";
import { toast } from "react-toastify";
import { loggingJiraTaskTrackedTimeInDB, syncTimeWithJira} from "../../services/jira.service";
import { loggingOpenProjectTaskTrackedTime, syncTimeWithOpenProject } from "../../services/openProject.service";
import UploadMeetingVideoDialog from "../../components/task/uploadMeetingDialog";
import User from "../../components/users";
import { UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL } from "../../services/const";
import { formatTimeWithSecond } from "../ProjectListPage";
import { createWorkerInterval } from "../../utils/components";
import { clearStateIssue, issueState } from "../../store/IssueSlice";
import FullScreenPopup from "../../components/popup/fullScreenPopup";
import { useNavigate } from 'react-router-dom';
import { clearProjectState } from "../../store/projectSlice";
import { clearUserState } from "../../store/userSlice";
import PopOver from "../../components/popup/logSummaryPopover";
import { showNotification } from "../../utils/notification";

function convertSecondsToHMS(seconds:number) {
  if (isNaN(seconds) || seconds < 0) {
      return "Invalid input";
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return {
      hours: hours,
      minutes: minutes,
      seconds: remainingSeconds
  };
}

function convertSecondsToMinutes(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  return minutes;
}

interface IjiraSpentTimePayload  {
  issueKey: string | undefined;
  started: string;
  timeSpentSeconds: number;
  projectKey: any;
  accountId: string | undefined;
}


const ProjectTrackerPage = () => {

  const projectState = useSelector((state: RootState) => state.project);
  const issueState = useSelector((state: RootState) => state.issue);
  const trackerState = useSelector((state: RootState) => state.tracker);
  const userState = useSelector((state: RootState) => state.user);
  const selectedProject = projectState?.selectedProject
  const projectName = projectState?.selectedProject?.name?.split('\n')[0];
  const projectTypeMenu = projectState?.projectTypeMenu
  const projectType = projectState?.projectType
  const taskName = issueState.issue;
  const isIssueTracking = trackerState.isTracking
  const projectLink = projectState?.selectedProject?.projectLink
  const projectLinkOfSelectedTask = issueState.projectLink 
  const issueId = issueState?.id
  const projectTrackedTime = projectState?.projects_trackedTime?.[selectedProject?.task_project_commonFieldForSpentTime!]
  const trackingStartedAt = trackerState?.trackingStartedAt
  const userDetails = userState?.user;
  const userLink = userDetails?.openProjectDetails?._links?.self?.href;
  const sessionExpire=trackerState.sessionExpire;
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const TIME_LOG_API_FAILED="TIME_LOG_API_FAILED"

  const [startAt, setStartAt] = useState<Date>();
  const [seconds, setSeconds] = useState<number>(0);  
  // const [seconds2, setSeconds2] = useState<number>(0);  
  const [uploadMeetingVideoDialog, setUploadMeetingVideoDialog] = useState(false);
  const [ webWorkIntervalCall,setWebWorkIntervalCall ] = useState({});
  const [ webWorkIntervalCallForSyncApi,setWebWorkIntervalCallSyncApi ] = useState({});
  const [localProjectTrackedTime, setLocalProjectTrackedTime] = useState<number>(0);
  const [unLoggedSeconds,setUnloggedSeconds] = useState<number>(0);
  const [lastIssueDetails,setLastIssueDetails] = useState<issueState|undefined>();
  const [failedJiraTimeLogPayload,setFailedJiraTimeLogPayload] = useState<IjiraSpentTimePayload[]>([])
  const [sessionExpireDialog, setSessionExpireDialog] = useState(false);
  const [isNotificationSent, setIsNotificationSent] = useState(false);

  const todayTrackedTime = useMemo(()=>{
    let totalSecond = 0 
    if(projectState?.projects_trackedTime){
      for(let task_project_commonFieldForSpentTime in projectState?.projects_trackedTime) {
        totalSecond += projectState?.projects_trackedTime?.[task_project_commonFieldForSpentTime] || 0
      }
    }
    return totalSecond
  },[projectState?.projects_trackedTime])

  const openUploadMeetingVideoDialog = ()=>{
    setUploadMeetingVideoDialog(true);
  }
  const closeUploadMeetingVideoDialog = (isMeetingUploaded:boolean)=>{
    setUploadMeetingVideoDialog(false);
    if(isMeetingUploaded){
      logSpentTime();
    }else{
      dispatch(setTrackingState(true));
    }
  }
  const logOpenProjectSpentTime = async (trackedSeconds:number,onSwitch:boolean = false) =>{
    const ldapUserLink = userLink;
    const spentOn = moment().format('YYYY-MM-DD');
    const trackedTime = convertSecondsToHMS(trackedSeconds)
    const payload = {
      // commented for feature reference
      // comment: {
      //         raw: "Test time_entries from UI"
      //     },
      "customField2": 0,
      spentOn,
      hours : trackedTime,
      
      _links : {
          project: {
            href: projectLink
        },
        workPackage: {
            href: onSwitch ? lastIssueDetails?.workPackagesLink : issueState?.workPackagesLink
        },
        user: {
            href: ldapUserLink
        }
      }
    }

    const response = await loggingOpenProjectTaskTrackedTime(payload)
    .catch((err)=>{
      toast.error('Error on update spent time')
    })
    if(response?.statusCode !== 200){
      throw TIME_LOG_API_FAILED;
    }
    dispatch(setTrackingTimeLogged(true))

  }
  const generateJiraSpentTimePayload = (trackedSeconds:number,onSwitch:boolean = false) => {
    return {
      issueKey: onSwitch ? lastIssueDetails?.key : issueState?.key,
      started: trackingStartedAt,
      timeSpentSeconds: trackedSeconds,
      projectKey: issueState.issueData.fields.project.key,
      accountId: userDetails?.jiraDetails?.accountId
    };
  }

  const logJiraSpentTime = async (payload :IjiraSpentTimePayload) =>{

    const response = await loggingJiraTaskTrackedTimeInDB(payload)
    .catch((err)=>{
      toast.error('Error on update spent time')
    })
    if(response?.statusCode !== 200){
      throw TIME_LOG_API_FAILED;
    }
    dispatch(setTrackingTimeLogged(true))

  }

  
  const handlePlayPause = () => {
    if(isIssueTracking) {
      dispatch(setTrackingState(false));
      showNotification({
        body: 'Tracking Stopped.'
      });
    } else {
      dispatch(setTrackingState(true));
      showNotification({
        body: `Started Time Tracking`
      });
    }
  }

  const getTodayTrackedTimeWithCurrentTrackingTimeInSeconds = () => {
    const selectedProjectTrackedTime = projectState?.projects_trackedTime?.[selectedProject?.projectKey!] || 0 ;
    return (todayTrackedTime + ( seconds - selectedProjectTrackedTime ))  || 0
  }

  const logSpentTime = async(isOnInterval=false, onSwitch:boolean = false) =>{
    // setSeconds2(0)
    // to handle the seconds on log with jira
    const secondsFromStartTime =  moment().unix()-moment(startAt).unix();
    const trackedTimeInSeconds = (secondsFromStartTime + unLoggedSeconds);
    const oldtrackedTimeInSeconds = (seconds + unLoggedSeconds - localProjectTrackedTime);
    const unLoggableSeconds = trackedTimeInSeconds % 60;
    setUnloggedSeconds(unLoggableSeconds);
    const trackedTimeInmin = Math.floor(trackedTimeInSeconds / 60);
    const trackedTimeInsecondWithoutExtratime = trackedTimeInmin * 60 ;
    let testingObj = {
      oldtrackedTimeInSeconds,
      secondsFromStartTime,
      startAt,
      seconds,
      localProjectTrackedTime,
      unLoggedSeconds,
      trackedTimeInSeconds,
      trackedTimeInsecondWithoutExtratime,
      unLoggableSeconds,
      projectTrackedTime
    }
    console.log(`testingObj`,testingObj)
    if(trackedTimeInsecondWithoutExtratime === 0) return ; 
    try {
      if(projectType === projectTypeMenu[0]) {
        // the time log with db is not handled for openProject so, the tracking update before api call
        const secondsFromStartTime =  moment().unix()-moment(startAt).unix();
        setLocalProjectTrackedTime(secondsFromStartTime +  localProjectTrackedTime);
        setStartAt(new Date(new Date().getTime() - 1000));
        dispatch(setTrackingStartedAt(moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS+0000')));

        await logOpenProjectSpentTime(trackedTimeInsecondWithoutExtratime,onSwitch);

        if(!isOnInterval) {
          syncWorkLog();
        }
      } else if (projectType === projectTypeMenu[2]) {
        const spentTimePayload = generateJiraSpentTimePayload(trackedTimeInsecondWithoutExtratime,onSwitch)
        await logJiraSpentTime(spentTimePayload).catch((error)=>{
          if(!isOnInterval){
            setFailedJiraTimeLogPayload([...failedJiraTimeLogPayload,spentTimePayload])
          }
          throw error
        });

        if(isOnInterval){
          // to handle the time log api fail on interval (update the tracking detail only log api is success)
          const secondsFromStartTime =  moment().unix()-moment(startAt).unix();
          setLocalProjectTrackedTime(secondsFromStartTime +  localProjectTrackedTime);
          setStartAt(new Date(new Date().getTime() - 1000));
          dispatch(setTrackingStartedAt(moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS+0000')));
          return;
        }

        if(failedJiraTimeLogPayload.length){
          let failedJiraTimeLogPayload_:any = failedJiraTimeLogPayload
          let logJiraSpentTimePromiseArr:Promise<void>[] = []
          for(let i = 0; i < failedJiraTimeLogPayload_.length; i++ ){
            logJiraSpentTimePromiseArr.push(logJiraSpentTime(failedJiraTimeLogPayload_[i]))
          }
          const results = await Promise.allSettled(logJiraSpentTimePromiseArr);
          for(let j=0; j< failedJiraTimeLogPayload_.length; j++){
            if(results?.[j]?.status === 'fulfilled'){
              failedJiraTimeLogPayload_[j] = true
            }
          }
          failedJiraTimeLogPayload_ = failedJiraTimeLogPayload_.filter((payload:any) => payload !== true)
          setFailedJiraTimeLogPayload(failedJiraTimeLogPayload_)
        }
        syncWorkLog()
      }
    } catch (error) {
      console.log(`[error] on logSpentTime `,error)
    }
  }

  const uploadMeetingAndLogSpentTime = () =>{
    openUploadMeetingVideoDialog();
  }

  const syncWorkLog = () => {
    if(projectType === projectTypeMenu[0]) {
      const openProjectAccessToken = localStorage.getItem('openProjectAccessToken');
      if((openProjectAccessToken && userDetails && userDetails.openProjectDetails && userDetails.openProjectDetails?.id )) {
        const userId = userDetails.openProjectDetails.id || "";
        syncTimeWithOpenProject(userId).catch(err => toast.error('Error while Syncing Work log with Open project'));
      }
    } else if (projectType === projectTypeMenu[2]) {
      const jiraAccessToken = localStorage.getItem('jiraAccessToken');
      if((jiraAccessToken && userDetails && userDetails.jiraDetails && userDetails.jiraDetails?.accountId )) {
        const accountId = userDetails?.jiraDetails?.accountId || "";
        syncTimeWithJira(accountId).catch(err => toast.error('Error while Syncing Work log with Jira'));
      }
    }
  }

  const handleLogin = () => {
    if(isIssueTracking) {
      logSpentTime();
    }
    dispatch(clearStateIssue());
    dispatch(clearProjectState());
    dispatch(clearUserState());
    dispatch(clearTrackingState());
    dispatch(setTrackingState(false));

    setSessionExpireDialog(false);
    navigate("/login");
  };

  const handleSessionExpired = (event: any) => {
    setSessionExpireDialog(event?.detail?.value || false);
    if(event?.detail?.value === true) {
      playSound();
      showNotification({
        body: 'Session Expired!, Login Again'
      });
    }
  }

  const playSound = () => {
    const audio = new Audio('/mixkit-software-interface-remove-2576.wav');
    audio.play();
  };

  
   // add web work interval  for time log sync api
   useEffect(() => {
    syncWorkLog();
    let  workerInterval = createWorkerInterval(()=>(setWebWorkIntervalCallSyncApi({})),3600000)
    return () =>{
      workerInterval?.stop();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(()=>{
    if(sessionExpire){
      console.log("logSpentTime")
      logSpentTime();
    }

  },[sessionExpire])

  // time log sync api call on web work interval change
  useEffect(()=>{
      syncWorkLog();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[webWorkIntervalCallForSyncApi])

  // set project tracked time to local tracked time of project
  useEffect(()=>{
      setLocalProjectTrackedTime(projectTrackedTime || 0);
      setSeconds(projectTrackedTime || 0);
  },[projectTrackedTime])

  // alert while close or refresh the tab
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isIssueTracking) {
        toast.warning('Stop the tracker before close or reload');
        const message = 'Tracker is in progress. Are you sure you want to leave?';
        event.returnValue = message;
        return message;
      }
      return null;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isIssueTracking]);

  // tracker timer
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isIssueTracking) {
      setLastIssueDetails(issueState)
      setStartAt(new Date());
      const currentTime =  new Date();
        timer = setInterval(() => {
          const start_at = startAt || currentTime;
          const trackedSec = moment().unix()-moment(start_at).unix();
          setSeconds(() => (( localProjectTrackedTime || 0 ) + trackedSec ));
          // setSeconds2(trackedSec)
        }, 1000);
      dispatch(setTrackingStartedAt(moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS+0000')));
    }

    return () =>{
      setStartAt(undefined);
      clearInterval(timer);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIssueTracking, localProjectTrackedTime]);

  // add web work interval 
  useEffect(()=>{
    let workerInterval : {stop: () => void;}
    if(isIssueTracking) {
      workerInterval = createWorkerInterval(()=>(setWebWorkIntervalCall({})),310000)
    }

    return () =>{
      workerInterval?.stop();
    }
  },[isIssueTracking])

  // api call on web work interval change
  useEffect(()=>{
    if(isIssueTracking) {
      logSpentTime(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[webWorkIntervalCall])

  // time log on tracker stop
  useEffect(()=>{
    if(projectLinkOfSelectedTask && !isIssueTracking){
      setLastIssueDetails(undefined)
      setLocalProjectTrackedTime(seconds || localProjectTrackedTime || 0);
      // customField4 is lable:string in open project to handel meeting task
      if(seconds -  localProjectTrackedTime){
        if( (issueState?.issueData?.customField4 == UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL ) || (Array?.isArray(issueState?.issueData?.fields?.labels) && issueState?.issueData?.fields?.labels?.includes(UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL))){
          uploadMeetingAndLogSpentTime();
        }else{
          logSpentTime();
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isIssueTracking]);

  // time log on task switch
  useEffect(()=>{
    if( isIssueTracking ){
      setLastIssueDetails(issueState)
      setLocalProjectTrackedTime(seconds || localProjectTrackedTime || 0);
      if(seconds -  localProjectTrackedTime){
        logSpentTime(false,true);
      }
      setStartAt(new Date());
      dispatch(setTrackingStartedAt(moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS+0000')));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[issueId]);

  useEffect(() => {
    window.addEventListener('sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, []);

  const notifyUserAboutRemainingTime = (trackedTimeInSeconds = 0) => {
    const timeTrackedOnIssue = trackedTimeInSeconds;
    const aggregateTimeEstimate = issueState.issueData?.fields?.aggregatetimeestimate || 0;
    if((aggregateTimeEstimate - timeTrackedOnIssue ) <= 300 && aggregateTimeEstimate > 0) {
      console.log('Notification sent', `${convertSecondsToMinutes(aggregateTimeEstimate - timeTrackedOnIssue)} mins left in ${issueState.key}`);
      showNotification({
        body: `${convertSecondsToMinutes(aggregateTimeEstimate - timeTrackedOnIssue)} mins left in ${issueState.key}`
      })
      setIsNotificationSent(true);
    }
  }

  useEffect(() => {
    const secondsFromStartTime =  moment().unix()-moment(startAt).unix();
    const trackedTimeInSeconds = (secondsFromStartTime + unLoggedSeconds);
    if(isIssueTracking && !isNotificationSent && projectType === projectTypeMenu[2]) {
      notifyUserAboutRemainingTime(trackedTimeInSeconds);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds])

  useEffect(() => {
    setIsNotificationSent(false);
  }, [issueState.id])

  return (
    <>
      <div className="projectTrackerDiv" >
        <div>
          <Button variant="contained" style={{
            padding: '5px 50px',
            margin: '20px 0px',
            fontSize: '21px',
            width: '70%',
            height: '35px'
          }}>
            <TaskTimer trackedTimeInSec={seconds}  />
          </Button>
        </div>
        <div className="user-drop-down-container">
          <User/>
        </div>
        <div className="spanDiv">
          <span className="projectName">{ projectName || 'WayMore' }</span>
          <span className="projectDescription">{ taskName }</span>
        </div>
        <div style={{
          padding: '10px',
          borderTop: '1px solid rgb(224, 224, 224)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <PopOver />
            <IconButton
            style={{
              border: '1px solid #e0e0e0',
              background: 'white',
            }}
            disabled={!issueState.id && !isIssueTracking }
            onClick={handlePlayPause}
          >{ isIssueTracking ? <StopSharpIcon fontSize="large" color="primary"/> : <PlayCircleIcon style={{ opacity: (!issueState.id && !isIssueTracking) ? '0.5 ' : '1' }} fontSize="large" color="primary"/>}</IconButton>
            <span className="playPauseTags">Today : {formatTimeWithSecond(getTodayTrackedTimeWithCurrentTrackingTimeInSeconds())} </span>
          </div>
        </div>
      </div>
      <UploadMeetingVideoDialog isOpen={uploadMeetingVideoDialog}  onClose={closeUploadMeetingVideoDialog} />

      <FullScreenPopup isOpen={sessionExpireDialog}>
        Session Expired !
        <div className="login-again">Please Login again</div>
        <Button variant="contained" className='popup-close' onClick={handleLogin}>LOGIN</Button>
      </FullScreenPopup>
    </>
  )
}

export default ProjectTrackerPage